import { Component, OnInit } from '@angular/core';
import { UIRouter, Transition } from "@uirouter/angular";
import { MailboxService } from '../mailbox-service/mailbox.service';
import { ProductsService } from '../products-service/products.service';
import swal from "sweetalert2";

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

const insurers = ['AA','Abbey Life','AChoice','Admiral Group','Admiral Insurance','Admiral Little Box','Adrian Flux Insurance Services',
        'Allianz','Allied Dunbar','Amlin','Ansvar Insurance','Antony Gibbs & Sons','Aon','Autonet Insurance Group','AutoSaint',
        'Aviva','AXA PPP Healthcare','AXA UK','Be Wiser Insurance','Beagle Street','Beazley Group','Bell','Benfield Group',
        'Bennetts','BG Insurance','BGL Group','Brand Partners','Bridle Insurance','Brightside Group','Brit PLC',
        'British Insurance Services','Budget Insurance','Camberford Law','Carole Nash','Carrot','Castle Cover','CGU plc',
        'Chart well','Chaucer Holdings','ChoiceQuote Insurance Services','Churchill Insurance','Clements WorldWide',
        'Clerical Medical','Collingwood','Combined Insurance','Cornish Mutual','Countrywide Legal Indemnities','CoverBox',
        'Daily Mail and General Trust','Devitt Insurance','Dial Direct','Diamond','Direct Choice','Direct Line','Drive',
        'Drive like a Girl','Drive Smart','Drivology','Eagle Star Insurance','Ecclesiastical Insurance','Elephant',
        'Endsleigh Insurance','Engage Mutual Assurance','Equitas','Equity Insurance Group','ESInsure','Esure',
        'Excel Insurance Solutions','First Central', 'First for Insurance','Flux Direct','Forces Financial','Friends Provident',
        'General Accident','GirlMotor','GoGirl','GoSkippy','Grove and Dean','Guardian Assurance Company',
        'Guardian Royal Exchange Assurance','Hand in Hand Fire & Life Insurance Society','Hastings Insurance','Health Shield',
        'Health-on-Line','Helpucover','Howden Insurance Brokers Limited','Hughes','Hyperperformance','Ignition','Ignotion',
        'Igo4insurance','Ingenie','Insure and Drive','Insure It All','Insure Ok','Insure Pink','Insure the Box','Insure wiser',
        'Insure your Motor','InsureandGo','John Lewis','Kwelm','Kwik FIt','LadyBird','Lancaster','Legal & General',
        'Legal and General','Lifesure Insurance Group','Liverpool Victoria','Lloyd\'s Agency Network','Lloyds Bank','Logical Choice',
        'Markerstudy Group','Marks and Spencers','Master Quote','MCE Insurance','More Than (company)','Motor Insurers\' Bureau',
        'Municipal Mutual Insurance','My motor Quote','MyPolicy','Nationwide','NCI Insurance','NFU Mutual','Nissan',
        'North British and Mercantile Insurance','North of England P&I Association','Northern Star Insurance Co','Norwich Union',
        'Novae Group','Octagon','Old Mutual','One Call','One Quote','Only Young Driver','Pavilion Insurance','Peoples Choice',
        'Performance Direct','Petplan Equine','Petplan UK','Phoenix Fire Office','Phoenix Group','PinkPound Insurance',
        'Police Mutual','Pool Re','Post Office','PremiumCHoice','Privilege','Privilege (insurance company)','Protect Your Bubble',
        'Provident','Prudential','QuickSure','Quote a Car','Quote Line Direct','Quote me Happy','RAC','RAC Insurance',
        'Refuge Assurance Company','Renault','Resolution Plc','Rias','Right Choice Insurance Brokers',
        'Royal Exchange Assurance Corporation','Royal Liver Assurance','Royal London Group','RSA Insurance Group',
        'Saffron Insurance Services Ltd','Saga','Sainsburys','Scottish Friendly','Scottish Widows','ScreenTrade','Sedgwick Group',
        'Sheila\'s Wheels','Simply Business','Stonebridge International Insurance Ltd','Suffolk Life','Sun Life & Provincial Holdings',
        'Sun Life Financial','SunLife','Sure Thing','Sureterm','SwiftCover','Swiftcover','Swinton','Swinton Insurance','Tesco',
        'The Co-operative Insurance','The Equitable Life Assurance Society','The Insurance Factory','The Insurance Line',
        'Totally Insured','UIA (Insurance)','Vauxhall','VitalityHealth','Westfield Health','Willis Group','Wise Driving','Wiser Choice',
        'Young Marmalade','Zenith','Zurich Insurance Group','Tokio Marine HCC','Hiscox','Lorega','Commercial Express','Professional Insurance Agents',
        'NIG','Powerplace','Towergate Underwriting','Pen Underwriting','Accelerate Underwriting','Gable','UK General','iPrism'];

//const products = [{'id':1,'name':'Car'},{'id':2,'name':'Home'},{'id':3,'name':'Cart'}];

@Component({
  selector: 'app-mailbox-overlay',
  templateUrl: './mailbox-overlay.component.html',
  styleUrls: ['./mailbox-overlay.component.less']
})
export class MailboxOverlayComponent implements OnInit {

  public convertEmail: any = {}
  private products
 

  constructor(private router: UIRouter, private transition: Transition, 
              private mailboxService : MailboxService,
              private productsService : ProductsService) {
  		  	
          this.products = this.productsService.products;

  }

  ngOnInit() {

  }
  hideOverlay() {
    this.router.stateService.go('app.mailbox.email')

  }

  convertEmailToPolicy(){

    this.mailboxService.convertEmailToPolicy(
      {email_id:this.transition.params().id,
      product_type:this.convertEmail.product.id,
      policy_reference: this.convertEmail.policy_reference,
      insurer:this.convertEmail.insurer,
      premium:this.convertEmail.product_premium,
      billing_period:this.convertEmail.billing_period,
      start_date:this.convertEmail.start_date,
      expiry_date:this.convertEmail.expiry_date,
      notes:this.convertEmail.notes
    });

    this.hideOverlay();

    swal({
        title: "We have set you up a product!",   
        type: "success",
        text: "It's waiting for you in your portfolio",
    })

    this.mailboxService.retrieveEmails();
    

  }

  searchInsurers = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : insurers.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

  

  searchProducts = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.products.value.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

     formatter = (x: {name: string}) => x.name;
}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/rooster/admin/src/app/mailbox-overlay/mailbox-overlay.component.ts